import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import apiClient from "../api/apiClient";
import { useSnackbar } from "../contexts/SnackbarContext";
import { getSelectedCountryId, clearCountryStorage } from "../utils/countryStorage";

export const useAxiosInterceptors = () => {
    const navigate = useNavigate();
    const { showMessage } = useSnackbar();

  useEffect(() => {
    // Interceptor de solicitud
    const requestInterceptor = apiClient.interceptors.request.use(
      (config) => {
        // 1. Buscamos primero si hay un token guardado directamente (Flujo Microsoft Azure)
        let token = localStorage.getItem("token");

        // 2. Si no hay token directo, lo buscamos dentro del objeto user (Flujo de Login Antiguo)
        if (!token) {
          const userStr = localStorage.getItem("user");
          // Validamos que el string exista y no sea la palabra "null" o "undefined"
          if (userStr && userStr !== "null" && userStr !== "undefined") {
            try {
              const userObj = JSON.parse(userStr);
              // Usamos ?. para evitar que explote, y revisamos 'token' (con soporte a tu antiguo 'toke' por si acaso)
              token = userObj?.token || userObj?.toke;
            } catch (error) {
              console.error("Error al parsear el usuario en el interceptor", error);
            }
          }
        }

        // 3. Si encontramos un token por cualquiera de las dos vías, lo inyectamos
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }

        // Multi-país: adjunta el país seleccionado para que el backend acote la información.
        // Se puede omitir por petición con { skipCountry: true } (p.ej. el mantenedor de usuarios,
        // que necesita ver los proyectos de todos los países).
        if (!(config as any).skipCountry) {
          const countryId = getSelectedCountryId();
          if (countryId != null) {
            config.headers["X-Country-Id"] = String(countryId);
          }
        }
        return config;
      },
      (error) => Promise.reject(error)
    );

    // Interceptor de respuesta
    const responseInterceptor = apiClient.interceptors.response.use(
      (response) => response,
      (error) => {
        console.log("ERRRRORR: ", error);
        if (error.response?.status === 401) {
          console.warn("Sesión expirada o token inválido");

          // Limpiamos ambos rastros para asegurar un cierre de sesión limpio
          localStorage.removeItem("user");
          localStorage.removeItem("token");
          clearCountryStorage();
          navigate("/", { replace: true });
          showMessage("Tu sesión ha expirado. Por favor inicia sesión nuevamente.", "warning");
          return Promise.resolve({ data: null });
        }
        return Promise.reject(error);
      }
    );

    // Limpiar interceptores al desmontar
    return () => {
      apiClient.interceptors.request.eject(requestInterceptor);
      apiClient.interceptors.response.eject(responseInterceptor);
    };
  }, [navigate, showMessage]);
};